import { rj } from "react-rocketjump"
import api from "../api"

export const RegistrazioneAziendaState = rj({
  name: "RegistrazioneAziendaState",
  effect: (data) => api.post("/api/signup", data),
})
